import * as adl from '@pollfish/pf-advanced-logic';
// import * as adl from '../../../../../../pf-advanced-logic/pf-advanced-logic/dist';
import {
  CarryForwardService,
  VisibilityService,
  shuffleArray,
  getAnswersShuffleType,
  getScorepointShuffleType,
  getGenericShuffleType,
  getShuffledAndCarriedForwardAnswers,
  base64,
  getDecodedText,
  enrichMatrixRows,
  isMatrix,
  isMatrixTypeLikert,
  isMatrixOpenEndedFamily,
  isNodeSupportAnswersVisibility,
  LoopAndMergeService,
  GroupNode,
  filterNonVisibleNodes,
  extractQuotaStrategies,
  QLUnifyService,
} from '@pollfish/pf-library-of-power';
// } from '../../../../../../pf-advanced-logic/pf-library-of-power/dist';

export const questionnaireLogicService = adl.QuestionnaireLogicService.withKnowledge();
export const questionnairePathTraversal = new adl.QuestionnairePathTraversal(
  questionnaireLogicService,
);
export const qlUnifyService = new QLUnifyService(questionnairePathTraversal);

export const {
  KnowledgeKeys,
  OutcomeType,
  FinalNode,
  ActionVisibilityValueType,
  Matcher,
  RespondentKnowledge,
  FinalGroupNode,
  StatementMergeItemTypes,
  VisibilityStatus,
  getNodeVisibility,
  QuotaAssignmentStrategy,
} = adl;

export const KnowledgeKeysByOutcomeType = {
  [adl.OutcomeType.Variable]: adl.KnowledgeKeys.Variables,
  [adl.OutcomeType.Answer]: adl.KnowledgeKeys.Visibility,
};

export const carryForwardService = new CarryForwardService();
export const loopAndMergeService = new LoopAndMergeService(carryForwardService);
export {
  VisibilityService,
  shuffleArray,
  getAnswersShuffleType,
  getScorepointShuffleType,
  getGenericShuffleType,
  getShuffledAndCarriedForwardAnswers,
  base64,
  getDecodedText,
  isMatrix,
  isMatrixTypeLikert,
  isMatrixOpenEndedFamily,
  enrichMatrixRows,
  isNodeSupportAnswersVisibility,
  GroupNode,
  filterNonVisibleNodes,
  extractQuotaStrategies,
};
